import { AppViewMode } from 'src/constants';
import { PortalConfig } from 'src/context/portalConfigContext';
import * as Colors from 'src/theme/colors';

/**
 * The accent color the MUI theme exposes as `palette.primary.main`, so
 * Tailwind-styled components can match it without going through the theme.
 */
export const getPrimaryMainColor = (portalConfig: PortalConfig): string => {
  if (portalConfig.viewMode !== AppViewMode.CLIENT) {
    return Colors.InternalAccent;
  }
  return (
    portalConfig.brand.clientAccentColor ||
    portalConfig.theme.palette.primary.main
  );
};
